var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"has-background-light",attrs:{"type":"is-outlined","icon-left":"file-export","label":_vm.label,"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('export')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }